import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n            <a href=\"", "", "\" class=", ">\n                <p class=", ">\n                    ", "\n                    <span class=", ">", "</span>\n                </p>\n            </a>\n            <div class=\"", "\">\n                <hr class=\"", "\" ref=", "/>\n            </div>\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { Component, html } from 'lib/component';
import anime from 'animejs';
import { ref } from 'lib/lit-ref';
import * as styles from './styles';
export default class NavLink extends Component {
  init() {
    this.options.autoDestroy = false;
  }

  render() {
    let item = this.item;
    let number = this.number;
    return html(_templateObject(), ENV.baseURL, item.url, styles.link, styles.text, item.title, styles.number, number.toString().padStart(2, '0'), styles.line, styles.lineInner, ref(this, 'line'));
  }

  onRender() {
    this.classList.add(styles.navlink);
  }

  animateIn(params, complete) {
    anime({
      targets: this.refs.line,
      translateX: ['-101%', '0%'],
      duration: 600,
      easing: 'easeOutCubic',
      complete
    });
  }

  animateOut(params, complete) {
    anime({
      targets: this.refs.line,
      translateX: ['0%', '101%'],
      duration: 400,
      easing: 'easeOutCubic',
      delay: 100,
      complete
    });
  }

}
customElements.define('rv-navlink', NavLink);